export * from '../oficial/list/arbitroList.component';
export * from '../oficial/create/arbitroCreate.component';
export * from '../oficial/edit/arbitroEdit.component';
export * from '../oficial/detail/arbitroDetail.component';
export * from '../oficial/search/arbitroSearch.component';